/**
 * defines type of the filter button
 */
export var FilterButtonType;
(function (FilterButtonType) {
    FilterButtonType["Select"] = "en-filter-button";
    FilterButtonType["Input"] = "en-search-filter-button";
    FilterButtonType["Number"] = "en-number-filter-button";
    FilterButtonType["Money"] = "en-money-filter-button";
    FilterButtonType["Address"] = "en-address-search-filter-button";
    FilterButtonType["Date"] = "en-date-filter-button";
    FilterButtonType["DateMonth"] = "en-date-month-filter-button";
    FilterButtonType["Autocomplete"] = "en-autocomplete-filter-button";
    FilterButtonType["InputMultiple"] = "en-multiple-search-filter-button";
})(FilterButtonType || (FilterButtonType = {}));
